import { useMemo } from 'react';
import { useBindViewer } from '../../hooks/useBindViewer';
import { canViewChannelsSection } from '../permissions';

export const useChannelsPermissions = () => {
  const bindViewer = useBindViewer();

  return useMemo(
    () => ({
      canViewChannelsSection: bindViewer(canViewChannelsSection),
    }),
    [bindViewer],
  );
};
